import { render } from "./ManageReviewsAccess.vue?vue&type=template&id=544a6f72&scoped=true"
import script from "./ManageReviewsAccess.vue?vue&type=script&lang=js"
export * from "./ManageReviewsAccess.vue?vue&type=script&lang=js"

import "./ManageReviewsAccess.vue?vue&type=style&index=0&id=544a6f72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544a6f72"]])

export default __exports__